import { render, staticRenderFns } from "./GoodsZtOrder.vue?vue&type=template&id=674fad56&"
import script from "./GoodsZtOrder.vue?vue&type=script&lang=js&"
export * from "./GoodsZtOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports